import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
export default {
  mixins: [renderFormMixins],
  name: "forgot",
  data: function data() {
    var _this = this;

    return {
      nameTabs: "name1",
      enterButton: this._vm.$t('loginArea.getvcode'),
      enterButton1: this._vm.$t('loginArea.getvcode'),
      formMoblie: {
        timezone: ""
      },
      //亚洲
      zoneListyz: [{
        "value": "Asia/Shanghai",
        "label": this._vm.$t('中国')
      }, {
        "value": "Asia/Tokyo",
        "label": this._vm.$t('日本')
      }, {
        "value": "Asia/Seoul",
        "label": this._vm.$t('韩国')
      }, {
        "value": "Asia/Kolkata",
        "label": this._vm.$t('印度')
      }, {
        "value": "Asia/Singapore",
        "label": this._vm.$t('新加坡')
      }, {
        "value": "Asia/Kuala_Lumpur",
        "label": this._vm.$t('马来西亚')
      }, {
        "value": "Asia/Bangkok",
        "label": this._vm.$t('泰国')
      }, {
        "value": "Asia/Ho_Chi_Minh",
        "label": this._vm.$t('越南')
      }, {
        "value": "Asia/Taipei",
        "label": this._vm.$t('台湾地区')
      }, {
        "value": "Asia/Hong_Kong",
        "label": this._vm.$t('香港地区')
      }, {
        "value": "Asia/Macau",
        "label": this._vm.$t('澳门地区')
      }, {
        "value": "Asia/Manila",
        "label": this._vm.$t('菲律宾')
      }, {
        "value": "Asia/Dubai",
        "label": this._vm.$t('阿联酋（迪拜）')
      }],
      //北美洲
      zoneListbmz: [{
        "value": "America/New_York",
        "label": this._vm.$t('美国（东部）')
      }, {
        "value": "America/Chicago",
        "label": this._vm.$t('美国（中部）')
      }, {
        "value": "America/Denver",
        "label": this._vm.$t('美国（山地）')
      }, {
        "value": "America/Los_Angeles",
        "label": this._vm.$t('美国（太平洋）')
      }, {
        "value": "America/Toronto",
        "label": this._vm.$t('加拿大（东部）')
      }, {
        "value": "America/Vancouver",
        "label": this._vm.$t('加拿大（西部）')
      }, {
        "value": "America/Mexico_City",
        "label": this._vm.$t('墨西哥')
      }],
      //欧洲
      zoneListoz: [{
        "value": "Europe/London",
        "label": this._vm.$t('英国')
      }, {
        "value": "Europe/Berlin",
        "label": this._vm.$t('德国')
      }, {
        "value": "Europe/Paris",
        "label": this._vm.$t('法国')
      }, {
        "value": "Europe/Rome",
        "label": this._vm.$t('意大利')
      }, {
        "value": "Europe/Madrid",
        "label": this._vm.$t('西班牙')
      }, {
        "value": "Europe/Moscow",
        "label": this._vm.$t('俄罗斯（莫斯科）')
      }, {
        "value": "Europe/Amsterdam",
        "label": this._vm.$t('荷兰')
      }, {
        "value": "Europe/Zurich",
        "label": this._vm.$t('瑞士')
      }],
      //大洋洲
      zoneListdyz: [{
        "value": "Australia/Sydney",
        "label": this._vm.$t('澳大利亚（东部）')
      }, {
        "value": "Australia/Adelaide",
        "label": this._vm.$t('澳大利亚（中部）')
      }, {
        "value": "Pacific/Auckland",
        "label": this._vm.$t('新西兰')
      }],
      //南美洲
      zoneListnmz: [{
        "value": "America/Sao_Paulo",
        "label": this._vm.$t('巴西（圣保罗）')
      }, {
        "value": "America/Argentina/Buenos_Aires",
        "label": this._vm.$t('阿根廷')
      }],
      //非洲
      zoneListfz: [{
        "value": "Africa/Johannesburg",
        "label": this._vm.$t('南非')
      }, {
        "value": "Africa/Cairo",
        "label": this._vm.$t('埃及')
      }, {
        "value": "Africa/Nairobi",
        "label": this._vm.$t('肯尼亚')
      }],
      butDisabled: false,
      butDisabled1: false,
      rules: {
        timezone: [{
          required: true,
          message: '时区不能为空',
          trigger: 'blur'
        }],
        new_password1: [{
          required: true,
          message: '新密码不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,
          message: '6-20位，至少包含字母数字其中两种',
          trigger: 'change'
        }],
        new_password2: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this._vm.$t('重复新密码不能为空')));
            } else if (value !== _this.formMoblie.new_password1) {
              callback(new Error(_this._vm.$t('新密码与重复新密码不一致')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      }
    };
  },
  props: {
    $store: {},
    edit: {},
    _vm: {}
  },
  computed: {
    userInfoStore: function userInfoStore() {
      var data = this.$store.state.user.userInfo;
      return data;
    }
  },
  methods: {
    clickChange: function clickChange(evt) {
      this.nameTabs = evt;
    },

    /**
     * 邮箱获取验证码
     */
    getEmailCode: function getEmailCode() {
      var _this2 = this;

      var time = 120,
          vm = this;
      var email = this.formEmail.email,
          mobTetx = "",
          url,
          params;
      vm.$refs.formEmail.validateField('email', function (valide) {
        if (valide === '') {
          mobTetx = vm._vm.$t('loginArea.emailIncorrect');
          url = "handleGetEmall";
          params = {
            email: email,
            type: 2
          };

          var callback = function callback(res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.butDisabled1 = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton1 = time + vm._vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton1 = vm._vm.$t('loginArea.getvcode');
                  vm.butDisabled1 = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this2.$Message.error(res.errorMsg);
            }
          };

          vm.$store.dispatch(url, params).then(function (res) {
            callback(res);
          });
        }
      });
    },
    handleSubmit: function handleSubmit(name, submit) {
      var _this3 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          submit();
        } else {
          _this3.$Message.error(_this3._vm.$t('loginArea.requireFieldsNotice'));
        }
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    var vm = this;

    if (this.edit) {
      vm.formMoblie.timezone = vm.userInfoStore.timezone;
    }
  }
};